import { EventEmitter } from 'events';

/**
 *
 *
 * @export
 * @class Event
 * @author zhenliang.sun
 */
export default class MyEvent {
  constructor() {
    this.emitter = new EventEmitter();
  }

  dispatch(type, data, data2, extData, ...args) {
    this.emitter.emit(type, data, data2, extData, args);
  }

  /**
   * 添加一个函数处理，注册到EventEmitter实例中
   *
   * @param {*} type
   * @param {*} handler
   * @param {boolean} [once=false]
   * @memberof Event
   */
  addEventListener(type, handler, once = false) {
    if (once) {
      this.emitter.once(type, handler);
    } else {
      this.emitter.on(type, handler);
    }
  }

  /**
   * 从EventEmitter中移除一个消息处理函数
   *
   * @param {*} type
   * @param {*} handler
   * @memberof Event
   */
  removeEventListener(type, handler) {
    this.emitter.removeListener(type, handler);
  }

  /**
   * 清空所有所注册的函数处理
   *
   * @memberof Event
   */
  removeAllListeners() {
    // 立即执行移除，存在问题， 移不掉
    // setTimeout(() => {
    //   emitter.removeAllListeners();
    // }, 0);

    // 用一个立即执行函数删除 emitter 里所有的事件
    (() => {
      this.emitter.removeAllListeners();
    })();
  }
}
